__turbopack_context__.v({
  "advantages": "BoltFix-module-scss-module__LGTLja__advantages",
  "button-wrapper": "BoltFix-module-scss-module__LGTLja__button-wrapper",
  "cta": "BoltFix-module-scss-module__LGTLja__cta",
  "wrapper": "BoltFix-module-scss-module__LGTLja__wrapper",
});
